import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

// Components
import { Button } from '@betareader/design-system';

import { withTranslation } from 'react-i18next';

// redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  addConversationMember,
  removeConversationMember,
  fetchContacts,
  setCurrentConversation,
} from '../../modules/message';

import Avatar from '../../components/avatar/avatar';
import BlockUserButton from '../../components/user/blockUserButton';

export class ConversationList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: undefined,
    };
  }

  componentDidMount() {
    const { idToken } = this.props;
    if (idToken !== undefined) {
      this.props.fetchContacts(idToken);
    }
  }

  removeMember = (event) => {
    const { contacts, currentConversation, idToken } = this.props;
    const member = contacts.find(user => user._id === event.currentTarget.dataset.memberUser);
    if (member) {
      // we have a conversation member to remove. go ahead and do it.
      if (!currentConversation.isNew) {
        // this is an existing conversation, update with backend
        this.props.removeConversationMember(idToken, {
          conversation: currentConversation,
          member,
        });
      }
      if (currentConversation.isNew) {
        // this is a new conversation, simply remove it from the currentConversation's members list
        const memberIndex = currentConversation.members.findIndex(
          user => user._id === member._id
        );
        const updatedMembersList = [...currentConversation.members];
        updatedMembersList.splice(memberIndex, 1);
        this.props.setCurrentConversation({
          ...currentConversation,
          members: updatedMembersList,
        });
      }
    }
  };

  addMember = (event) => {
    const { contacts, currentConversation, idToken } = this.props;
    const member = contacts.find(user => user._id === event.currentTarget.dataset.memberUser);
    if (member) {
      // we have a conversation member to add. go ahead and do it.
      if (!currentConversation.isNew) {
        // this is an existing conversation, update with backend
        this.props.addConversationMember(idToken, {
          conversation: currentConversation,
          member,
        });
      }
      if (currentConversation.isNew) {
        // this is a new conversation, simply remove it from the currentConversation's members list
        this.props.setCurrentConversation({
          ...currentConversation,
          members: [...currentConversation.members, member],
        });
      }
    }
  };

  render() {
    const { t, currentConversation, contacts } = this.props;
    const { search } = this.state;
    if (!currentConversation) {
      return null;
    }

    const { members } = currentConversation;

    // filter out the contacts who are not yet selected
    const remainingContacts = contacts.filter(contact => {
      const alreadySelected =
        members.findIndex(user => user._id === contact._id) !== -1;
      let stringMatch = true;
      if (search && search.length > 0) {
        stringMatch = (contact.displayName || '').toLocaleLowerCase().includes(search.toLocaleLowerCase());
      }
      return !alreadySelected && stringMatch;
    });

    return (
      <section style={{ margin: 'var(--br-space-4) 0' }}>
        <h3>{t('To')}:</h3>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {members.length === 0 && <li>{t('AddMembersFromContacts')}</li>}
          {members.map(user => (
            <li key={user._id} style={{
              display: 'flex', alignItems: 'center', gap: 'var(--br-space-2)',
              padding: 'var(--br-space-2)', borderBottom: '1px solid var(--br-border)'
            }}>
              <Avatar name={user.displayName} diameter={30} />
              <span style={{ flex: 1 }}>{user.displayName}</span>
              {currentConversation.isNew && (
                <Button variant='secondary' size='small' data-member-user={user._id}
                  onClick={this.removeMember} aria-label={`${t('Remove')} ${user.displayName}`}>
                  {t('Remove')}
                </Button>
              )}
              <BlockUserButton userId={user._id} displayName={user.displayName}
                size='small' basic onBlocked={() => {}} />
            </li>
          ))}
        </ul>
        {currentConversation.isNew && (
          <>
            <label className='br-field' htmlFor='conversation-contact-search'>
              <span className='br-field__label'>{t('Contacts')}</span>
              <input id='conversation-contact-search' className='br-field__input'
                type='search' placeholder={t('Search')} value={search || ''}
                onChange={event => this.setState({ search: event.target.value })} />
            </label>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {remainingContacts.map(user => (
                <li key={user._id} style={{
                  display: 'flex', alignItems: 'center', gap: 'var(--br-space-2)',
                  padding: 'var(--br-space-2)', borderBottom: '1px solid var(--br-border)'
                }}>
                  <Avatar name={user.displayName} diameter={30} />
                  <span style={{ flex: 1 }}>{user.displayName}</span>
                  <Button variant='secondary' size='small' data-member-user={user._id}
                    onClick={this.addMember} aria-label={`${t('Add')} ${user.displayName}`}>
                    {t('Add')}
                  </Button>
                </li>
              ))}
              {remainingContacts.length === 0 && <li>{t('NothingHere')}</li>}
            </ul>
          </>
        )}
      </section>
    );
  }
}

// redux stuff
// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  userProfile: state.user.userProfile,
  idToken: state.user.idToken,
  currentConversation: state.message.currentConversation,
  contacts: state.message.contacts,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addConversationMember,
      removeConversationMember,
      fetchContacts,
      setCurrentConversation,
    },
    dispatch
  );

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(ConversationList))
);
